import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'get'

export default class OspreyOffersGetById extends BaseAction {
    constructor(dataKey) {
        const id = '3090ed04-fcc6-4695-af86-0cff89a5138b'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getById(offerId, params) {
        this.params = params
        this.path = `/${resource}/${offerId}`

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-get-by-id.js